// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wZPU","left":"styles_left__1ycjL"};